import AbstractApiService from 'src/services/abstractApiService';
import { AUTH_URL, DOC2API_URL, api } from 'pages/APIs';

export default class SupplierGroupApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async create(data: any): Promise<any> {
    return super.post(DOC2API_URL + '/supplier_group/add_supplier_group', data);
  }

  public async list(skip = 0, limit = 100, sortBy?: string, order?: string, keyword?: string): Promise<any> {
    const queryParams = new URLSearchParams();
    queryParams.append('skip', skip.toString());
    queryParams.append('limit', limit.toString());
    if (sortBy) {
      queryParams.append('sort_by', sortBy);
    }
    if (order) {
      queryParams.append('order', order);
    }
    if (keyword) {
      queryParams.append('keyword', keyword);
    }
    return super.get(DOC2API_URL + `/supplier_group/get_list_supplier_group?${queryParams.toString()}`);
  }

  public async edit(id: string, data: any): Promise<any> {
    const formData = new FormData();
    formData.append('group_name', data.group_name);
    formData.append('title', data.title);

    return super.put(DOC2API_URL + `/supplier_group/by-id/${id}`, formData);
  }

  public async delete(id: string): Promise<any> {
    return super.delete(DOC2API_URL + `/supplier_group/by-id/${id}`, {});
  }
}
